import { Component } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { Usuario } from '../../../models/usuario';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: []
})
export class AppHeaderComponent {

  usuario: Usuario;

  constructor(
    public dialog: MatDialog,
    public authService: AuthService,
    private route: Router
  ) {

  }

  logout(): void {
    this.authService.logout();
    this.route.navigate(['/login']);
  }

  configuracion(): void {
    this.authService.logout();
    this.route.navigate(['/parametros']);
  }

}
